var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2539 23.994H19.3261V17.6578C19.3261 15.2204 17.3284 13.2434 14.8792 13.2434H4.92773V23.994H4V12.3286H14.8792C17.8418 12.3286 20.2539 14.7231 20.2539 17.664V24.0001V23.994Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1269 10.2041C9.29427 10.2041 6.9873 7.91403 6.9873 5.10206C6.9873 2.2901 9.29427 0 12.1269 0C14.9596 0 17.2666 2.2901 17.2666 5.10206C17.2666 7.91403 14.9596 10.2041 12.1269 10.2041ZM12.1269 0.92095C9.80761 0.92095 7.91504 2.79355 7.91504 5.10206C7.91504 7.41058 9.80143 9.28318 12.1269 9.28318C14.4525 9.28318 16.3389 7.41058 16.3389 5.10206C16.3389 2.79355 14.4525 0.92095 12.1269 0.92095Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6753 15.5027L9.59717 13.1083L10.3022 12.5066L11.6753 14.0906L13.0545 12.5066L13.7534 13.1083L11.6753 15.5027Z",
    fill: "#C72035"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6569 23.2942L9.1582 20.6173L11.6569 14.9626L14.4401 20.6541L11.6569 23.2942ZM10.2529 20.4331L11.694 21.9803L13.3021 20.4515L11.694 17.1606L10.2467 20.4331H10.2529Z",
    fill: "#C72035"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiles);
export default __webpack_public_path__ + "static/media/profiles.29149dda.svg";
export { ForwardRef as ReactComponent };